import { render, staticRenderFns } from "./pageCard.vue?vue&type=template&id=025dc7aa&scoped=true"
import script from "./pageCard.vue?vue&type=script&lang=js"
export * from "./pageCard.vue?vue&type=script&lang=js"
import style0 from "./pageCard.vue?vue&type=style&index=0&id=025dc7aa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "025dc7aa",
  null
  
)

export default component.exports